import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { getPostsByTag } from '../content/config';

const TagPage = () => {
  const { tag } = useParams();
  const posts = getPostsByTag(tag);

  return (
    <div className="mx-auto max-w-[900px] px-4 py-10">
      <Seo title={`Tag #${tag}`} description={`Tous les articles lies au tag ${tag}`} path={`/tags/${tag}`} />
      <h1 className="lmd-editorial-title text-4xl font-bold text-slate-900">#{tag}</h1>
      <p className="mt-2 text-slate-600">{posts.length} article(s)</p>

      <div className="mt-6 space-y-3">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/article/${post.slug}`}
            className="block rounded-lg border border-slate-200 bg-white px-4 py-3 hover:border-indigo-300"
          >
            <p className="text-xs uppercase tracking-wider text-slate-500">
              {post.categoryLabel} - {post.date}
            </p>
            <h2 className="mt-1 text-lg font-bold text-slate-900">{post.title}</h2>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TagPage;
